import { messagesNow } from '@/i18n'
import { messages } from './messages'

// Код провала джобы перевода статьи → текст автору. `Map`, а не объектный литерал:
// у литерала код `constructor` вернул бы функцию, и фолбэк на текст сервера не сработал бы.
const jobFailed = () => {
  const m = messagesNow(messages)
  return new Map([
    ['safety_blocked', m.translateSafety],
    ['html_invalid', m.translateHtml],
    ['gemini_permanent', m.translateGemini],
    ['gemini_retryable_exhausted', m.translateRetryable],
    // Автор нажал «Обновить», пока модель работала: черновик заморожен, перевод не записан.
    ['review_in_progress', m.translateInReview],
  ])
}

export const translationFailedText = (code: string | null, serverMessage: string | null): string =>
  (code !== null ? jobFailed().get(code) : undefined) ||
  serverMessage ||
  messagesNow(messages).translateFailed
